import React, { useEffect, useState } from 'react'
import { Switcher } from 'chemistry'
import { getLocale } from 'client/common/utils'
import {
  getSelectedWithToggle,
  onSelectFilter
} from 'client/fragments/listerFragment/components/Filters/CheckListFilter'
import { isFlagInGA, pushFlagToDatalayer } from 'client/common/gtmEvents'
import { SHOW_AVAILABILITY_TOGGLE } from 'common/constants'
import { useSelector } from 'react-redux'

const AVAILABILITY_FILTER_NAMES = ['Aankoopmogelijkheden', 'Bezorg- en ophaalopties', 'Possibilités d’achat']
const inStoreNL = 'Beshikbaar in winkel'
const inStoreFR = 'Disponible en magasin'
const homeDeliveryNL = 'Thuisbezorgd'
const homeDeliveryFR = 'Livraison à domicile'

const AvailabilitySwitcher = ({ collection, filterProcessedData, format, lang }) => {
  const [isSwitched, setIsSwitched] = useState(false)
  const [isSwitcherClickedOn, setIsSwitcherClickedOn] = useState(false)
  const isBricoFr = getLocale(format, lang) === 'fr_BE'

  const flagsToGA = useSelector(store => store.data?.flags?.flagsToGA)

  const availabilityFilter = collection.find(f => AVAILABILITY_FILTER_NAMES.includes(f.name))
  const inStoreAvailabilityItem = isBricoFr
    ? availabilityFilter.items.find(i => i.value === inStoreFR)
    : availabilityFilter.items.find(i => i.value === inStoreNL)
  const homeDeliveryAvailabilityItem = isBricoFr
    ? availabilityFilter.items.find(i => i.value === homeDeliveryFR)
    : availabilityFilter.items.find(i => i.value === homeDeliveryNL)

  useEffect(() => {
    if (!availabilityFilter) return

    const checkedItems = availabilityFilter.items.map(i => i.checked && i.value)

    if (
      (checkedItems.includes(inStoreNL) || checkedItems.includes(inStoreFR)) &&
      !checkedItems.includes(homeDeliveryNL) &&
      !checkedItems.includes(homeDeliveryFR)
    ) {
      setIsSwitched(true)
    } else if (
      (checkedItems.includes(inStoreNL) || checkedItems.includes(inStoreFR)) &&
      (checkedItems.includes(homeDeliveryNL) || checkedItems.includes(homeDeliveryFR)) &&
      isSwitcherClickedOn
    ) {
      setIsSwitched(true)
      // unselect Thuisbezorgd
      onSelectFilter({
        filter: { ...availabilityFilter },
        availabilityItem: { ...homeDeliveryAvailabilityItem },
        filterPosition: 'top',
        onClickStickyFilter: () => null,
        onChange: filterProcessedData.onChange,
        getSelectedWithToggleFunc: getSelectedWithToggle
      })()
    } else {
      setIsSwitched(false)
    }
  }, [availabilityFilter, collection, filterProcessedData.onChange, homeDeliveryAvailabilityItem, isSwitcherClickedOn])

  const onClickAvailabilitySwitcher = () => {
    if (isFlagInGA({ flagsToGA, ldFlag: SHOW_AVAILABILITY_TOGGLE })) {
      pushFlagToDatalayer({
        ldFlag: SHOW_AVAILABILITY_TOGGLE,
        ldVariation: 'toggle_clicked'
      })
    }
    setIsSwitcherClickedOn(!isSwitched)
    // select/unselect inStore checkbox
    onSelectFilter({
      filter: { ...availabilityFilter },
      availabilityItem: { ...inStoreAvailabilityItem },
      filterPosition: 'top',
      onClickStickyFilter: () => null,
      onChange: filterProcessedData.onChange,
      getSelectedWithToggleFunc: getSelectedWithToggle
    })()
  }

  return (
    <Switcher
      isDisabled={!inStoreAvailabilityItem}
      isChecked={isSwitched}
      colorScheme='yellow'
      size='lg'
      scale={1.2}
      label={isBricoFr ? inStoreFR : 'Beschikbaar in winkel'}
      onChange={onClickAvailabilitySwitcher}
      showTooltip={true}
      tooltip={{
        content: isBricoFr
          ? 'Affichez uniquement les articles disponibles en magasin. Certains peuvent également être commandés en ligne. Consultez la page produit pour voir toutes les options.'
          : 'Gebruik deze filter om alleen producten te zien die beschikbaar zijn in onze winkels. Sommige kun je ook online bestellen. Bekijk de productpagina voor alle mogelijkheden.'
      }}
    />
  )
}

export default AvailabilitySwitcher
